import React from "react"

import {useTranslation} from "react-i18next"

const LoadingIndicator = ({message}) => {
  const {t} = useTranslation()
  return (
    <p class="sh-loading-indicator">
      {message ? message : t("loading")}
      <div class="ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </p>
  )
}

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.js